"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.outDuration = exports.inDuration = exports.easing = exports.collapsibleVisibleOpacity = exports.collapsibleVisibleMaxSize = exports.collapsibleHiddenOpacity = exports.collapsibleHiddenMaxSize = exports.animateOutOpacityConfig = exports.animateOutMaxSizeConfig = exports.animateInOpacityConfig = exports.animateInMaxSizeConfig = void 0;
var _tokens = require("../motion/tokens");
const collapsibleHiddenOpacity = 0;
exports.collapsibleHiddenOpacity = collapsibleHiddenOpacity;
const collapsibleVisibleOpacity = 1;
exports.collapsibleVisibleOpacity = collapsibleVisibleOpacity;
const collapsibleHiddenMaxSize = 0;
// for web, mobile will be determined by content height dynamically
exports.collapsibleHiddenMaxSize = collapsibleHiddenMaxSize;
const collapsibleVisibleMaxSize = 1000;
exports.collapsibleVisibleMaxSize = collapsibleVisibleMaxSize;
const easing = 'global';
exports.easing = easing;
const inDuration = 'slow1';
exports.inDuration = inDuration;
const outDuration = 'moderate3';
exports.outDuration = outDuration;
const animateInOpacityConfig = {
  vertical: {
    property: 'opacity',
    easing,
    duration: inDuration,
    toValue: collapsibleVisibleOpacity,
    fromValue: collapsibleHiddenOpacity,
    useNativeDriver: false
  },
  horizontal: {
    property: 'opacity',
    easing: 'exitFunctional',
    duration: 'fast1',
    delay: _tokens.durations.fast1,
    toValue: collapsibleVisibleOpacity,
    fromValue: collapsibleHiddenOpacity,
    useNativeDriver: false
  }
};
exports.animateInOpacityConfig = animateInOpacityConfig;
const animateOutOpacityConfig = {
  vertical: Object.assign({}, animateInOpacityConfig.vertical, {
    duration: outDuration,
    toValue: collapsibleHiddenOpacity,
    fromValue: collapsibleVisibleOpacity
  }),
  horizontal: Object.assign({}, animateInOpacityConfig.horizontal, {
    toValue: collapsibleHiddenOpacity,
    fromValue: collapsibleVisibleOpacity,
    delay: undefined
  })
};
exports.animateOutOpacityConfig = animateOutOpacityConfig;
const animateInMaxSizeConfig = {
  vertical: {
    property: 'height',
    easing,
    duration: inDuration,
    toValue: collapsibleVisibleMaxSize,
    fromValue: collapsibleHiddenMaxSize,
    useNativeDriver: false
  },
  horizontal: {
    property: 'width',
    easing: 'global',
    duration: 'fast1',
    useNativeDriver: false,
    toValue: collapsibleVisibleMaxSize,
    fromValue: collapsibleHiddenMaxSize
  }
};
exports.animateInMaxSizeConfig = animateInMaxSizeConfig;
const animateOutMaxSizeConfig = {
  vertical: Object.assign({}, animateInMaxSizeConfig.vertical, {
    duration: outDuration,
    toValue: collapsibleHiddenMaxSize,
    fromValue: collapsibleVisibleMaxSize
  }),
  horizontal: Object.assign({}, animateInMaxSizeConfig.horizontal, {
    delay: _tokens.durations.fast1,
    toValue: collapsibleHiddenMaxSize,
    fromValue: collapsibleVisibleMaxSize
  })
};
exports.animateOutMaxSizeConfig = animateOutMaxSizeConfig;